import React, { useState, useEffect } from 'react'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { Loading } from '../../components'
import { GSXService } from '../../services'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import { showErrorToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
import { Button } from 'react-bootstrap'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'

export type GSXPart={
  imageUrl?:string
  number?:string
  description?:string
  eeeCodes?:string
  typeDescription?:string
  stockPrice?:string
  exchangePrice?:string
  laborTier?:string
}

export type PartDataTableProps={
  device_identifier:string,
  onSelection:(item:GSXPart)=>void
  extraItems?:Array<string>
}

export const PartDataTable = ({ device_identifier, onSelection,extraItems }:PartDataTableProps) => {
  const dispatch = useDispatch()
  const [parts, setParts] = useState()

useEffect(() => {
  const getData = async () => {
    const data = {
      devices: [{ id: device_identifier }],
    };

    try {
      const response = await new GSXService().part_summary({ search_criteria: data });

      const a: GSXPart[] = extraItems?.map(n => ({
        number: n,
        description: n,
        eeeCodes: n,
        typeDescription: n,
        stockPrice: "2,000",
        exchangePrice: "2,000"
      })) ?? [];

      const safeResponse: GSXPart[] = Array.isArray(response) ? response : [];
      setParts([...safeResponse, ...a]);
    } catch (error) {
      setParts([]);
      dispatch(showErrorToast('Error while getting part summary', error.response));
    }
  };

  getData();
}, [device_identifier, dispatch, extraItems]);

  const columns = [
    {
      dataField: 'imageUrl',
      formatter: (cell, row) => {
        return (
          <img alt={row.typeDescription} height={32} width={32} src={cell} />
        )
      },
    },
    {
      dataField: 'number',
      text: 'Number',
      filter: textFilter(),
    },
    {
      dataField: 'description',
      text: 'Description',

      filter: textFilter({
        style: {
          display: 'block',
        },
      }),
    },
    {
      dataField: 'eeeCodes',
      text: 'EEE Code',
      filter: textFilter(),
    },
    {
      dataField: 'typeDescription',
      text: 'Type Description',
    },
    {
      dataField: 'stockPrice',
      text: 'Stock Price',
    },
    {
      dataField: 'exchangePrice',
      text: 'Exchange Price',
    },
    {
      dataField: 'laborTier',
      text: 'Labor Tier',
    },
    {
    dataField: 'action',
    text: 'Action',
    isDummyField: true,
    formatter: (_cell, row) => (
      <Button size="sm" variant="dark" onClick={() => onSelection(row)}>
        Add
      </Button>
    ),
  },
  ]

  return (
    <>
      {parts ? (
        <ToolkitProvider keyField="id" data={parts} columns={columns} search>
          {(props) => (
            <div className="mt-5">
              <BootstrapTable
                filterPosition="top"
                filter={filterFactory()}
                {...props.baseProps}
                pagination={paginationFactory({ hideSizePerPage: true })}
              />
            </div>
          )}
        </ToolkitProvider>
      ) : (
        <Loading />
      )}
    </>
  )
}
